'use es6';

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import notificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import { routerMiddleware } from 'DesignData/middlewares/routerMiddleware';
import rootReducer from 'DesignManagerIde/reducers';
import applicationMiddlware from 'DesignManagerIde/middlewares/install';
import UsageTracker from 'DesignManagerIde/utils/usageTracker/usageTracker';
import { usageTrackerMiddleware } from 'usage-tracker-redux';
import usageTrackerHandlers from 'DesignManagerIde/utils/usageTracker/usageTrackerHandlers';
export default function configureStore(initialState, browserHistory) {
  const middleware = [usageTrackerMiddleware(UsageTracker, usageTrackerHandlers), notificationMiddleware, thunk, routerMiddleware(browserHistory), ...applicationMiddlware];
  const createStoreWithMiddleware = applyMiddleware(...middleware)(createStore);
  const store = createStoreWithMiddleware(rootReducer, initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
  return store;
}